import styled from 'styled-components';

import Msg from 'components/Message';

export const Message = styled(Msg).attrs(() => ({
  type: 'error',
  form: 1,
  small: 1,
}))`
  text-align: right;
`;
